// extracted by mini-css-extract-plugin
export default {"icon":"ZuMKUz1m6c1hEw5VetH_","left":"YNfKjL_T8OsbDNCDosug","right":"EN8pHKEZVL8wvtkZK3Zq"};